import { z } from "zod";
// External chat identity linking (Slack now, MS Teams next). See ADR-0028.
export const LinkChatIdentityRequest = z.object({
    /** One-time HMAC token minted by the chat bot's link prompt. */
    token: z.string().min(1),
});
export const LinkChatIdentityResponse = z.object({
    provider: z.enum(["slack", "msteams"]),
    linked: z.literal(true),
});
// Microsoft Teams tab-SSO identity linking. Unlike Slack's one-time HMAC
// token (an unlinked bot user proving their intent), the caller here is
// already an authenticated HealthOS session; the AAD ids come from the
// Teams-tab-trusted host-auth profile, not a bot-issued token.
export const LinkTeamsTabIdentityRequest = z.object({
    aadTenantId: z.string().min(1),
    aadObjectId: z.string().min(1),
});
// Admin-facing Slack workspace installation (OAuth multi-tenant, ADR-0028).
export const SlackWorkspaceStatusResponse = z.object({
    /** False when the deployment has no OAuth app credentials configured. */
    installAvailable: z.boolean(),
    workspace: z
        .object({
        teamName: z.string(),
        installedAt: z.string(),
    })
        .nullable(),
});
export const SlackInstallUrlResponse = z.object({
    /** slack.com/oauth/v2/authorize URL carrying a one-shot state. */
    url: z.string(),
});
export const SlackWorkspaceDisconnectResponse = z.object({
    disconnected: z.literal(true),
});
//# sourceMappingURL=chat.js.map